// src/components/templates/MainLayout.js
import React from 'react';
import Navbar from '../organisms/Navbar';
import { Box, Container } from '@mui/material';

const MainLayout = ({ children }) => {
  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <Navbar />
      <Container
        component="main"
        sx={{
          flexGrow: 1,
          px: { xs: 0, sm: 4 }, // Adjust horizontal padding for mobile (xs) and small screens (sm)
          py: { xs: 0, sm: 4 }, // Adjust vertical padding for mobile (xs) and small screens (sm)
          maxWidth: { xs: '100%', lg: 'lg', xl: 'xl' }, // Responsive max width
        }}
      >
        {children}
      </Container>
    </Box>
  );
};

export default MainLayout;
